import { useMutation } from '@apollo/client';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import {
  createTheme,
  ThemeProvider,
  StyledEngineProvider,
} from '@mui/material/styles';
import { useSnackbar } from 'notistack';
import React from 'react';
import { red } from '@mui/material/colors';
import { SAVE_DRAFT } from '../../../helpers/graphql/drafts';
import CancelScheduleIcon from '@mui/icons-material/CancelScheduleSend';

const theme = createTheme({
  palette: {
    primary: red,
  },
});

export default function UnscheduleDraftDialog({
  btnText,
  setOpen,
  id,
  setPosts,
  posts,
  onDelete,
}) {
  const [addDraft] = useMutation(SAVE_DRAFT);

  const { enqueueSnackbar } = useSnackbar();

  const handleSetUnscheduled = () => {
    if (onDelete) onDelete();
    else {
      const newPosts = [];
      posts.forEach(post => {
        if (post.id !== id) {
          newPosts.push(post);
        }
      });
      setPosts(newPosts);
      window.location.href = '/dashboard/drafts';
    }
  };

  const handleUnschedule = () => {
    addDraft({
      variables: {
        draft: {
          id,
          scheduledDate: null,
        },
      },
    })
      .then(({ data }) => {
        if (data.addDraft.success) {
          handleSetUnscheduled();
          setOpen(undefined);
        } else {
          enqueueSnackbar(
            `Draft could not be unscheduled: ${data.addDraft.message}`,
            {
              variant: 'error',
            },
          );
        }
      })
      .catch(() => {
        enqueueSnackbar('Draft could not be unscheduled', {
          variant: 'error',
        });
      });
  };

  return (
    <Dialog
      open={id !== undefined}
      onClose={() => setOpen(undefined)}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">{btnText}?</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Are you sure that you want to cancel posting the scheduled post &quot;
          {posts.map(draft => {
            if (draft.id === id) return draft.title || 'Untitled Draft';
          })}
          &quot;?
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => setOpen(undefined)} color="primary">
          Cancel
        </Button>{' '}
        <StyledEngineProvider injectFirst>
          <ThemeProvider theme={theme}>
            <Button
              variant="contained"
              onClick={handleUnschedule}
              color="primary"
            >
              <CancelScheduleIcon />
              <span className="pl-1">Revert</span>
            </Button>
          </ThemeProvider>
        </StyledEngineProvider>
      </DialogActions>
    </Dialog>
  );
}
